import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Billing - Direct Debit</Typography>
      <p>If you are on our monthly contract plan, then we will bill you via Direct Debit.</p>
      <p>Please click the [SETUP DIRECT DEBIT] button and complete the Stripe form 
        which will open on the right hand side of the browser
      </p>

      <p>Please remember to update your mandate if you change bank accounts.</p>
    </div>
  )
}

export default HelpText